import Component from '../Component';

class Line extends Component
{
    constructor(startNode, endNode, props)
    {
        super(null, props);

        this.start = startNode;
        this.end   = endNode;
    }

    getDefaultProps()
    {
        return {
            color: 'blur',
            size: 1,
        };
    }

    getPath()
    {
        return `M${this.start.x} ${this.start.y}L${this.end.x} ${this.end.y}`;
    }

    getAttributes()
    {
        return {
            stroke: this.props.color,
            opacity: 0,
            'stroke-width': `${this.props.size}px`,
        }
    }
}

export default Line;